import React from 'react';
import {View, StyleSheet, Pressable, Text} from 'react-native';
import {tokens} from '../theme/tokens';
import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';

export const Actions: React.FC<{
  orderId: string;
  onViewReceipt: (id: string) => void;
}> = ({orderId, onViewReceipt}) => {
  const {borderColor, textColor} = (() => {
    switch (Settings.buildType) {
      case 'canteen':
        return {
          borderColor: Styles.Colors.Canteen.darkGreen,
          textColor: Styles.Colors.Canteen.darkGreen,
        };
      case 'companykitchen':
        return {
          borderColor: Styles.Colors.CompanyKitchen.green,
          textColor: Styles.Colors.CompanyKitchen.black,
        };
      case 'refive':
        return {
          borderColor: Styles.Colors.Refive.activeFooterBlue,
          textColor: Styles.Colors.Refive.activeFooterBlue,
        };
      default:
        return {
          borderColor: Styles.Colors.PayNew.primary01,
          textColor: Styles.Colors.PayNew.primary01,
        };
    }
  })();

  return (
    <View style={styles.wrap}>
      <Pressable
        onPress={() => onViewReceipt(orderId)}
        accessibilityLabel={Localized.Labels.view_receipt}
        accessibilityRole="button"
        testID="btn_view_receipt"
        hitSlop={{top: 10, bottom: 10, left: 10, right: 10}}
        style={[styles.button, {borderColor}]}
      >
        <Text style={[styles.buttonText, {color: textColor}]}>
          {Localized.Labels.view_receipt}
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: tokens.spacing.sm,
  },
  button: {
    alignSelf: 'center',
    backgroundColor: 'transparent',
    paddingVertical: 8,
    paddingHorizontal: 20,
    borderWidth: 2,
    borderRadius: 32,
  },
  buttonText: {
    textAlign: 'center',
    fontSize: Styles.Fonts.f8,
    fontWeight: '700',
    fontFamily: Styles.FontFamily.latoRegular,
    textTransform: 'none',
    lineHeight: 19.6,
  },
});
export default Actions;
